import React from "react";
import LibraryPage from "./pages/LibraryPage";

export const libraryRoutes = [
  { path: "/library", element: <LibraryPage /> },
];
